export default {"src":"/_next/static/media/kitchen.c8f61d29.svg","height":125,"width":125,"blurWidth":0,"blurHeight":0};